import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const sel = "h-9 rounded-lg border px-2 text-xs";

export const AssignBar = ({ reps, rep, setRep, onChange }) => {
  const split = async (only) => {
    if (!window.confirm(only ? "Split all unassigned shoppers evenly across active reps?" : "Re-split ALL shoppers evenly across active reps? Current assignments will change.")) return;
    try { const { data } = await api.post("/api/mystery/assign/split", { only_unassigned: only }); toast.success(`Assigned ${data.assigned} shoppers across ${data.reps} reps`); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3 bg-slate-50 rounded-xl p-3" data-testid="ms-assign-bar">
      <select value={rep} onChange={e => setRep(e.target.value)} className={sel} data-testid="ms-rep-filter">
        <option value="">All shoppers</option><option value="none">Unassigned ({reps?.unassigned ?? 0})</option>
        {reps?.reps.map(r => <option key={r.id} value={r.id}>{r.name} ({r.shoppers})</option>)}
      </select>
      <button onClick={() => split(true)} className="h-9 px-3 rounded-full bg-slate-900 text-white text-xs font-bold" data-testid="ms-split-unassigned">Split unassigned evenly</button>
      <button onClick={() => split(false)} className="h-9 px-3 rounded-full border text-xs font-bold" data-testid="ms-split-all">Re-split all</button>
      <span className="text-xs text-slate-500">{reps?.reps.length ?? 0} active reps</span>
    </div>
  );
};

export const RepPicker = ({ u, reps, onChange }) => {
  const set = async (rep_id) => { try { await api.post("/api/mystery/assign", { shopper_ids: [u.id], rep_id }); onChange(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <select value={u.assigned_rep_id || ""} onChange={e => set(e.target.value)} className={sel} data-testid={`ms-assign-${u.id}`}>
      <option value="">Unassigned</option>
      {u.assigned_rep_id && !reps?.reps.some(r => r.id === u.assigned_rep_id) && <option value={u.assigned_rep_id}>{u.assigned_rep_name}</option>}
      {reps?.reps.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
    </select>
  );
};
